/**
 * BUGARIO SIDE CART v2.2 — FINAL
 *
 * FIXES from v2.1:
 * 1. Suppresses native Shopify theme cart drawer/page (aggressive interception)
 * 2. Fastrr: calls shiprocketCheckoutEvents.buyCart(event) directly
 * 3. Color sort: by availability (most-available-sizes = popular color first)
 * 4. Volume discounts: display-only (auto-applied by Shopify automatic discounts)
 * 5. No sticky cart btn / bottom bar (GemPages sticky ATC already present)
 * 6. COD +₹100 / Prepaid 10% extra off on cart value
 */

(function () {
  'use strict';

  const D = {
    milestones: [
      { threshold: 1, label: 'Free Shipping', icon: '🚚', type: 'shipping' },
      { threshold: 2, label: 'Extra 10% OFF', icon: '🏷️', type: 'discount' },
      { threshold: 3, label: 'Extra 15% OFF', icon: '🏷️', type: 'discount' }
    ],
    currency: '₹',
    upsellProductHandle: '',
    upsellTitle: 'Try Another Colour',
    maxUpsells: 8,
    freeGiftProducts: [],
    freeGiftThreshold: 3999,
    freeGiftMessage: '🎁 You\'ve unlocked a FREE gift! Choose one:',
    availableCoupons: [],
    announcementText: '🎁 Buy 2, Get 20% OFF | Buy 3+, Get 30% OFF | Free Shipping on Prepaid',
    cartReserveMinutes: 0,   // DISABLED — remove fake urgency for premium brand

    // Explicit color sort order (highest selling first)
    colorSortOrder: ['Nude', 'Leopard Coffee', 'Leopard Pink', 'Black', 'Red', 'Coffee', 'Gray', 'White'],

    // Urgency labels per color (static, you control these)
    colorLabels: {
      'Nude': 'Bestseller', 'Leopard Coffee': 'Bestseller', 'Leopard Pink': 'Bestseller',
      'Black': 'Selling Fast', 'Red': 'Selling Fast',
      'Coffee': 'Popular', 'Gray': 'New', 'White': 'New'
    },

    // Popular combo — one-tap "Add All 3"
    comboColors: ['Nude', 'Black', 'Leopard Coffee'],
    comboTitle: '🔥 Most Popular Combo',

    // COD / Prepaid — REMOVED from cart (Fastrr handles this)
    showCodPrepaid: false,
    codExtraCharge: 100,           // +₹100 on COD
    prepaidDiscountPercent: 10,    // 10% extra off on prepaid

    showEDD: true,
    eddText: 'Estimated Delivery: 3-5 Business Days',
    eddApiEndpoint: '',

    // Volume discounts — display only. Actual discounts are Shopify automatic discounts.
    showBulkDiscounts: true,
    bulkDiscounts: [
      { qty: 2, label: 'Buy 2', discount: '20% OFF' },
      { qty: 3, label: 'Buy 3+', discount: '30% OFF' }
    ],

    trustBadges: [
      { icon: '🔒', label: 'Secure Checkout' },
      { icon: '↩️', label: 'Easy Returns' },
      { icon: '✅', label: '100% Genuine' }
    ],

    abTestEnabled: false, abTestId: 'sc_v2', abVariants: { A: {}, B: {} },
    trackGA4: true, trackMetaPixel: true,
    showRecentlyViewed: true, maxRecentlyViewed: 4,

    // No sticky btn — GemPages already has one
    showStickyBtn: false,
    showBottomBar: false
  };

  const C = Object.assign({}, D, window.BugarioCartConfig || {});

  let state = {
    cart: null, isOpen: false, isLoading: false,
    timerSeconds: C.cartReserveMinutes * 60, timerInterval: null,
    appliedCoupon: null, upsellColors: [], productData: null,
    _colorKey: 'option1', _sizeKey: 'option2', _productId: null,
    isCouponOpen: false, freeGiftSelected: null, recentlyViewed: [], abVariant: 'A',
    _exitNudgeShown: false
  };

  // ── UTILS ──
  const $ = (s, p) => (p || document).querySelector(s);
  const $$ = (s, p) => (p || document).querySelectorAll(s);
  function delegate(p, ev, sel, fn) { p.addEventListener(ev, e => { const t = e.target.closest(sel); if (t) fn.call(t, e); }); }
  function fp(paise) { return C.currency + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
  function fr(r) { return C.currency + Number(r).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }

  // ── A/B ──
  function initAB() {
    if (!C.abTestEnabled) return;
    let v = localStorage.getItem('bg_ab_' + C.abTestId);
    if (!v) { v = Math.random() < 0.5 ? 'A' : 'B'; localStorage.setItem('bg_ab_' + C.abTestId, v); }
    Object.assign(C, C.abVariants[v] || {}); state.abVariant = v;
  }

  // ── ANALYTICS ──
  const Ax = {
    track(ev, d = {}) {
      d.ab = state.abVariant;
      if (C.trackGA4 && window.gtag) try { window.gtag('event', ev, d); } catch (e) {}
      if (C.trackMetaPixel && window.fbq) {
        try {
          const m = { view_cart: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };
          if (m[ev]) window.fbq('track', m[ev], { value: d.value, currency: 'INR', content_ids: d.ids || [d.id] });
          else window.fbq('trackCustom', ev, d);
        } catch (e) {}
      }
    }
  };

  // ── RECENTLY VIEWED ──
  const RV = {
    K: 'bg_rv',
    load() {
      try {
        const raw = JSON.parse(localStorage.getItem(this.K)) || [];
        // Nuclear cleanup: filter out ANY entry with missing/bad data
        state.recentlyViewed = raw.filter(p =>
          p && typeof p === 'object' &&
          p.id && p.title &&
          typeof p.title === 'string' &&
          p.title !== 'undefined' && p.title !== 'null' && p.title.length > 1 &&
          p.image && typeof p.image === 'string' && p.image.startsWith('http') &&
          p.url && typeof p.url === 'string'
        );
        localStorage.setItem(this.K, JSON.stringify(state.recentlyViewed));
      } catch (e) { state.recentlyViewed = []; localStorage.removeItem(this.K); }
    },
    add(p) {
      if (!p?.id || !p.title || typeof p.title !== 'string' || p.title === 'undefined' || !p.image || !p.image.startsWith('http')) return;
      state.recentlyViewed = state.recentlyViewed.filter(x => x.id !== p.id);
      state.recentlyViewed.unshift(p);
      state.recentlyViewed = state.recentlyViewed.slice(0, 10);
      try { localStorage.setItem(this.K, JSON.stringify(state.recentlyViewed)); } catch (e) {}
    },
    track() {
      if (window.meta?.product) {
        const p = window.meta.product;
        if (p.title && typeof p.title === 'string' && p.featured_image && typeof p.featured_image === 'string' && p.featured_image.startsWith('http')) {
          this.add({ id: p.id, title: p.title, image: p.featured_image, price: p.price || 0, url: '/products/' + (p.handle || '') });
        }
      }
    },
    get() {
      const ids = state.cart ? state.cart.items.map(i => i.product_id) : [];
      return state.recentlyViewed.filter(p =>
        !ids.includes(p.id) && p.title && p.title !== 'undefined' && p.image && p.image.startsWith('http')
      ).slice(0, C.maxRecentlyViewed);
    }
  };

  // ── CART API ──
  const API = {
    async get() { return (await fetch('/cart.js', { credentials: 'same-origin' })).json(); },
    async add(items) { return (await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: Array.isArray(items) ? items : [items] }) })).json(); },
    async change(line, qty, props) { const b = { line, quantity: qty }; if (props) b.properties = props; return (await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) })).json(); },
    async getProduct(handle) { const r = await fetch('/products/' + handle + '.js', { credentials: 'same-origin' }); if (!r.ok) throw new Error(handle + ' not found (' + r.status + ')'); return r.json(); }
  };

  // ══════════════════════════════════════════════════════════════
  // COLOR-GROUPED UPSELLS — SORTED BY POPULARITY
  // ══════════════════════════════════════════════════════════════
  async function loadColorUpsells() {
    if (!C.upsellProductHandle) { console.warn('[BG] Set upsellProductHandle in config'); return; }
    try {
      // CACHE: only fetch product data ONCE, then reuse
      if (!state.productData) {
        console.log('[BG] Fetching product:', C.upsellProductHandle);
        const product = await API.getProduct(C.upsellProductHandle);
        state.productData = product;
        state._productId = product.id;

        let cIdx = 0, sIdx = 1;
        if (product.options?.length >= 2) {
          product.options.forEach((name, i) => {
            const n = (typeof name === 'string' ? name : name.name || '').toLowerCase();
            if (n.includes('color') || n.includes('colour')) cIdx = i;
            if (n.includes('size')) sIdx = i;
          });
        }
        state._colorKey = 'option' + (cIdx + 1);
        state._sizeKey = 'option' + (sIdx + 1);
        state._colorIdx = cIdx;
        state._sizeIdx = sIdx;

        // Build color groups ONCE
        const colorMap = new Map();
        product.variants.forEach(v => {
          const color = v[state._colorKey]; if (!color) return;
          if (!colorMap.has(color)) colorMap.set(color, { color, image: null, sizes: [], totalAvailable: 0, soldOutCount: 0 });
          const g = colorMap.get(color);
          g.sizes.push({ size: v[state._sizeKey], variantId: v.id, available: v.available, price: v.price, cp: v.compare_at_price });
          if (v.available) g.totalAvailable++; else g.soldOutCount++;
          if (!g.image && v.featured_image?.src) g.image = v.featured_image.src;
        });
        const colors = [...colorMap.keys()];
        colors.forEach((c, i) => { const g = colorMap.get(c); if (!g.image && product.images?.[i]) g.image = product.images[i]; if (!g.image && product.images?.[0]) g.image = product.images[0]; });

        state._allColorGroups = [...colorMap.values()];
        console.log('[BG] Colors cached:', colors.join(', '));
      }

      // FILTER: runs on every cart change — instant, no network
      const cartColors = new Set();
      const cartSizes = new Set();
      state.cart?.items.forEach(item => {
        if (item.product_id === state._productId && item.variant_title) {
          const parts = item.variant_title.split('/').map(s => s.trim());
          if (parts[state._colorIdx]) cartColors.add(parts[state._colorIdx]);
          if (parts[state._sizeIdx]) cartSizes.add(parts[state._sizeIdx]);
        }
      });
      state._customerSize = [...cartSizes][0] || '';

      const order = C.colorSortOrder || [];
      state.upsellColors = state._allColorGroups
        .filter(g => !cartColors.has(g.color) && g.totalAvailable > 0)
        .sort((a, b) => {
          const aP = order.indexOf(a.color), bP = order.indexOf(b.color);
          return (aP >= 0 ? aP : 999) - (bP >= 0 ? bP : 999);
        })
        .slice(0, C.maxUpsells);

      renderUpsells();
    } catch (e) {
      console.error('[BG] Upsell failed:', e.message);
    }
  }

  function renderUpsellCard(g) {
    const img = g.image ? g.image.replace(/(\.[^.]+)$/, '_300x$1') : '';
    const availSizes = g.sizes.filter(s => s.available);
    const custSize = state._customerSize;
    const defaultSize = availSizes.find(s => s.size === custSize) || availSizes[0];
    if (!defaultSize) return '';
    const price = defaultSize.price, cp = defaultSize.cp;
    const disc = cp && cp > price;
    const pct = disc ? Math.round((1 - price / cp) * 100) : 0;
    const opts = availSizes.map(s =>
      `<option value="${s.variantId}" data-price="${s.price}" data-cp="${s.cp || 0}" ${s.variantId === defaultSize.variantId ? 'selected' : ''}>${s.size}</option>`
    ).join('');
    const label = C.colorLabels?.[g.color] || '';
    const labelClass = label === 'Bestseller' ? 'best' : label === 'Selling Fast' ? 'hot' : label === 'New' ? 'new' : '';

    return `
    <div class="bg-sc-upsell-card" data-color="${g.color}">
      <div class="bg-sc-upsell-img">
        ${img ? `<img src="${img}" alt="${g.color}" loading="lazy" />` : '<div style="width:100%;height:100%;background:var(--bg-sc-bg-tertiary)"></div>'}
        ${disc ? `<span class="bg-sc-upsell-badge">${pct}% OFF</span>` : ''}
      </div>
      <div class="bg-sc-upsell-info">
        <div class="bg-sc-upsell-name-row">
          <p class="bg-sc-upsell-name">${g.color}</p>
          ${label ? `<span class="bg-sc-upsell-label ${labelClass}">${label}</span>` : ''}
        </div>
        <div class="bg-sc-upsell-price-row">
          <span class="bg-sc-upsell-price">${fp(price)}</span>
          ${disc ? `<span class="bg-sc-upsell-mrp">${fp(cp)}</span>` : ''}
        </div>
        <div class="bg-sc-select-wrap">
          <span class="bg-sc-select-label">Size:</span>
          <select class="bg-sc-upsell-size-select" data-color="${g.color}">${opts}</select>
          <span class="bg-sc-select-arrow">▾</span>
        </div>
        <button class="bg-sc-upsell-add" data-variant-id="${defaultSize.variantId}" data-color="${g.color}">+ Add</button>
      </div>
    </div>`;
  }

  function renderUpsells() {
    const el = $('#bg-sc-upsell'), car = $('#bg-sc-upsell-carousel');
    if (!el || !car) return;
    if (!state.upsellColors.length) { el.style.display = 'none'; return; }
    el.style.display = 'block';
    car.innerHTML = state.upsellColors.map(renderUpsellCard).join('');
  }

  // ── POPULAR COMBO — one tap "Add All" ──
  function renderCombo() {
    const el = $('#bg-sc-combo');
    if (!el || !C.comboColors?.length || !state._allColorGroups) return;
    const n = state.cart ? state.cart.item_count : 0;

    // Only show when cart has 1 item (push from 1 to 3)
    if (n !== 1) { el.style.display = 'none'; return; }

    // Find combo colors not already in cart
    const cartColors = new Set();
    state.cart?.items.forEach(item => {
      if (item.product_id === state._productId && item.variant_title) {
        const parts = item.variant_title.split('/').map(s => s.trim());
        if (parts[state._colorIdx]) cartColors.add(parts[state._colorIdx]);
      }
    });

    const comboToAdd = C.comboColors.filter(c => !cartColors.has(c));
    if (comboToAdd.length === 0) { el.style.display = 'none'; return; }

    // Get images and variant IDs for combo colors
    const comboItems = comboToAdd.map(color => {
      const group = state._allColorGroups.find(g => g.color === color);
      if (!group) return null;
      const sz = group.sizes.find(s => s.size === state._customerSize && s.available) || group.sizes.find(s => s.available);
      if (!sz) return null;
      return { color, image: group.image ? group.image.replace(/(\.[^.]+)$/, '_100x$1') : '', variantId: sz.variantId, price: sz.price };
    }).filter(Boolean);

    if (comboItems.length === 0) { el.style.display = 'none'; return; }

    const comboPrice = comboItems.reduce((s, i) => s + i.price, 0);
    const variantIds = comboItems.map(i => i.variantId).join(',');

    // Discount applies to ENTIRE cart (existing items + combo items)
    const existingCartPrice = state.cart.total_price; // paise
    const totalCartAfter = existingCartPrice + comboPrice; // paise — full cart with combo added
    const totalAfterQty = n + comboItems.length;

    let discPct = 0;
    if (totalAfterQty >= 3) discPct = 15;
    else if (totalAfterQty >= 2) discPct = 10;

    const discountedTotal = Math.round(totalCartAfter * (1 - discPct / 100));
    const savings = totalCartAfter - discountedTotal;

    el.style.display = 'block';
    el.innerHTML = `
      <div class="bg-sc-combo-inner">
        <div class="bg-sc-combo-header">
          <span class="bg-sc-combo-title">${C.comboTitle}</span>
          <span class="bg-sc-combo-discount">Extra ${discPct}% OFF</span>
        </div>
        <div class="bg-sc-combo-row">
          <div class="bg-sc-combo-images">${comboItems.map(i => `<img src="${i.image}" alt="${i.color}" />`).join('<span class="bg-sc-combo-plus">+</span>')}</div>
          <div class="bg-sc-combo-cta">
            <div class="bg-sc-combo-pricing">
              <span class="bg-sc-combo-final">${fp(discountedTotal)}</span>
              <span class="bg-sc-combo-mrp">${fp(totalCartAfter)}</span>
            </div>
            <button class="bg-sc-combo-add" data-variants="${variantIds}">Add All ${comboItems.length}</button>
          </div>
        </div>
        <div class="bg-sc-combo-save">Total for ${totalAfterQty} items · Save ${fp(savings)}!</div>
      </div>`;
  }

  // ── SAVINGS NUDGE (inline, shows exact ₹ saved by adding 1 more) ──
  function renderSavingsNudge() {
    const el = $('#bg-sc-savings-nudge');
    if (!el || !state.cart) return;
    const n = state.cart.item_count;

    if (n === 1) {
      // Adding 1 more = 2 total = 10% off entire cart
      const totalFull = 1499 * 2;
      const totalDisc = Math.round(totalFull * 0.90);
      const save = totalFull - totalDisc;
      el.style.display = 'block';
      el.innerHTML = `<span>Add 1 more → Pay <strong>${fr(totalDisc)}</strong> instead of ${fr(totalFull)} · <span class="bg-sc-nudge-save">Save ${fr(save)}</span></span>`;
    } else if (n === 2) {
      // Adding 1 more = 3 total = 15% off entire cart
      const totalFull = 1499 * 3;
      const totalDisc = Math.round(totalFull * 0.85);
      const save = totalFull - totalDisc;
      el.style.display = 'block';
      el.innerHTML = `<span>Add 1 more → Pay <strong>${fr(totalDisc)}</strong> instead of ${fr(totalFull)} · <span class="bg-sc-nudge-save">Save ${fr(save)}</span></span>`;
    } else {
      el.style.display = 'none';
    }
  }

  // ── CART ITEM ──
  function renderItem(item, idx) {
    const disc = item.original_price > item.final_price;
    const pct = disc ? Math.round((1 - item.final_price / item.original_price) * 100) : 0;
    const img = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
    const vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const parts = (vt || '').split('/').map(s => s.trim());
    const note = item.properties?._note || '';

    // Inline variant switcher
    let sw = '';
    if (state.productData && item.product_id === state._productId) {
      const ci = parseInt(state._colorKey.replace('option', '')) - 1;
      const si = parseInt(state._sizeKey.replace('option', '')) - 1;
      const curC = parts[ci] || '', curS = parts[si] || '';
      const allC = [...new Set(state.productData.variants.filter(v => v.available).map(v => v[state._colorKey]))];
      const allS = [...new Set(state.productData.variants.filter(v => v[state._colorKey] === curC && v.available).map(v => v[state._sizeKey]))];
      sw = `<div class="bg-sc-item-variant-switcher">
        <select class="bg-sc-item-variant-sel" data-line="${idx+1}" data-type="color" data-current-size="${curS}">${allC.map(c => `<option ${c===curC?'selected':''}>${c}</option>`).join('')}</select>
        <select class="bg-sc-item-variant-sel" data-line="${idx+1}" data-type="size" data-current-color="${curC}">${allS.map(s => `<option ${s===curS?'selected':''}>${s}</option>`).join('')}</select>
      </div>`;
    }

    return `
    <div class="bg-sc-item" data-line="${idx+1}" data-key="${item.key}">
      <div class="bg-sc-item-image">${img ? `<img src="${img}" alt="${item.product_title}" loading="lazy" />` : ''}</div>
      <div class="bg-sc-item-details">
        <div class="bg-sc-item-top-row">
          <a href="${item.url}" class="bg-sc-item-title">${item.product_title}</a>
          <button class="bg-sc-item-remove" data-line="${idx+1}">✕</button>
        </div>
        ${sw || (vt ? `<p class="bg-sc-item-variant">${vt}</p>` : '')}
        <div class="bg-sc-item-bottom-row">
          <div class="bg-sc-qty-stepper">
            <button class="bg-sc-qty-btn" data-line="${idx+1}" data-action="decrease">−</button>
            <span class="bg-sc-qty-value">${item.quantity}</span>
            <button class="bg-sc-qty-btn" data-line="${idx+1}" data-action="increase">+</button>
          </div>
          <span class="bg-sc-item-line-total">${fp(item.final_line_price)}</span>
        </div>
      </div>
    </div>`;
  }

  // ── PROGRESS ──
  function updateProgress() {
    if (!state.cart) return;
    const qty = state.cart.item_count;
    const ms = C.milestones;
    const max = ms[ms.length - 1].threshold;
    const pct = Math.min((qty / max) * 100, 100);

    const fill = $('#bg-sc-progress-fill');
    if (fill) fill.style.width = pct + '%';

    const msg = $('#bg-sc-progress-msg');
    const trackWrap = $('#bg-sc-progress-track-wrap');
    const progressEl = $('#bg-sc-progress');
    let allDone = true;

    if (msg) {
      let txt = '';
      for (const m of ms) {
        if (qty < m.threshold) {
          const need = m.threshold - qty;
          txt = `Add <strong>${need} more item${need > 1 ? 's' : ''}</strong> for <strong>${m.label}</strong> ${m.icon}`;
          allDone = false;
          break;
        }
      }
      if (allDone && qty > 0) txt = '🎉 All rewards unlocked!';
      else if (qty === 0) { txt = `Add ${ms[0].threshold} item for ${ms[0].label} ${ms[0].icon}`; allDone = false; }
      msg.innerHTML = txt;
    }

    if (trackWrap) trackWrap.style.display = allDone ? 'none' : 'block';
    if (progressEl) progressEl.classList.toggle('bg-sc-progress-done', allDone && qty > 0);

    if (!allDone) {
      const mk = $('#bg-sc-progress-milestones'), lb = $('#bg-sc-progress-labels');
      if (mk) mk.innerHTML = ms.map(m => {
        const p = (m.threshold / max) * 100, ok = qty >= m.threshold;
        return `<div class="bg-sc-milestone-marker ${ok ? 'unlocked' : ''}" style="left:${p}%"><span>${ok ? '✓' : m.icon}</span></div>`;
      }).join('');
      if (lb) lb.innerHTML = ms.map(m => {
        const p = (m.threshold / max) * 100;
        return `<span class="bg-sc-milestone-label ${qty >= m.threshold ? 'unlocked' : ''}" style="left:${p}%">${m.label}</span>`;
      }).join('');
    }
  }

  // ── COUPONS ──
  function renderCoupons() {
    const el = $('#bg-sc-coupons-list');
    if (!el || !C.availableCoupons.length) { const w = $('#bg-sc-available-coupons-wrap'); if (w) w.style.display = 'none'; return; }
    el.innerHTML = C.availableCoupons.map(c => `<div class="bg-sc-coupon-card"><div class="bg-sc-coupon-card-left"><span class="bg-sc-coupon-code-display">${c.code}</span><span class="bg-sc-coupon-desc">${c.description}</span></div><button class="bg-sc-coupon-use" data-code="${c.code}">Apply</button></div>`).join('');
  }
  async function applyCoupon(code) {
    if (!code) return;
    const msg = $('#bg-sc-coupon-message');
    try { setLoading(true); await fetch('/discount/'+encodeURIComponent(code), { method:'GET', credentials:'same-origin', redirect:'follow' }); state.cart = await API.get(); state.appliedCoupon = code;
      if (msg) { msg.innerHTML = `<span class="bg-sc-coupon-success">✓ "${code}" applied!</span>`; setTimeout(() => msg.innerHTML = '', 3000); }
      const a = $('#bg-sc-coupon-applied'); if (a) { a.style.display = 'flex'; a.innerHTML = `<span class="bg-sc-coupon-applied-tag">🏷️ ${code} <button class="bg-sc-coupon-remove">✕</button></span>`; }
      const inp = $('#bg-sc-coupon-input'); if (inp) inp.value = '';
      renderCart(); Ax.track('apply_coupon', { coupon: code });
    } catch (e) { if (msg) { msg.innerHTML = '<span class="bg-sc-coupon-error">Invalid code</span>'; setTimeout(() => msg.innerHTML = '', 3000); } }
    finally { setLoading(false); }
  }
  async function removeCoupon() { setLoading(true); await fetch('/discount/0', { method:'GET', credentials:'same-origin', redirect:'follow' }); state.cart = await API.get(); state.appliedCoupon = null; const a = $('#bg-sc-coupon-applied'); if (a) { a.style.display='none'; a.innerHTML=''; } renderCart(); setLoading(false); }

  // ── FREE GIFT ──
  function checkGift() {
    const el = $('#bg-sc-free-gift'); if (!el || !C.freeGiftProducts.length) return;
    const t = state.cart ? state.cart.total_price / 100 : 0;
    if (t >= C.freeGiftThreshold) {
      el.style.display = 'block';
      el.innerHTML = `<div class="bg-sc-gift-header">${C.freeGiftMessage}</div><div class="bg-sc-gift-options">${C.freeGiftProducts.map(g => `<button class="bg-sc-gift-option ${state.freeGiftSelected===g.variantId?'selected':''}" data-variant-id="${g.variantId}"><img src="${g.image}" alt="${g.title}" /><span class="bg-sc-gift-name">${g.title}</span>${state.freeGiftSelected===g.variantId?'<span class="bg-sc-gift-check">✓</span>':''}</button>`).join('')}</div>`;
    } else { el.style.display = 'none'; if (state.freeGiftSelected) removeGift(); }
  }
  async function selectGift(vid) { if (state.freeGiftSelected) await removeGift(); try { setLoading(true); await API.add([{id:vid,quantity:1,properties:{_is_free_gift:'true'}}]); state.freeGiftSelected = vid; state.cart = await API.get(); renderCart(); } finally { setLoading(false); } }
  async function removeGift() { if (!state.cart || !state.freeGiftSelected) return; const i = state.cart.items.findIndex(x => x.variant_id === state.freeGiftSelected && x.properties?._is_free_gift === 'true'); if (i >= 0) await API.change(i+1, 0); state.freeGiftSelected = null; }

  // ── BULK DISCOUNTS — compact when highest tier hit ──
  function renderBulk() {
    const el = $('#bg-sc-bulk-discounts');
    if (!el || !C.showBulkDiscounts || !C.bulkDiscounts.length) return;
    const qty = state.cart ? state.cart.item_count : 0;
    if (qty === 0) { el.style.display = 'none'; return; }
    el.style.display = 'block';

    let totalDisc = 0;
    if (state.cart) {
      state.cart.items.forEach(i => { if (i.original_price > i.final_price) totalDisc += (i.original_price - i.final_price) * i.quantity; });
      totalDisc += (state.cart.total_discount || 0);
    }

    // Find highest matched tier
    const highest = [...C.bulkDiscounts].reverse().find(b => qty >= b.qty);
    // Find next tier to motivate
    const next = C.bulkDiscounts.find(b => qty < b.qty);

    if (highest && !next) {
      // All tiers hit — collapse to inline success
      el.innerHTML = `<div class="bg-sc-bulk-inline">✅ <strong>${highest.discount}</strong> applied${totalDisc > 0 ? ' — Saving ' + fp(totalDisc) + '!' : ''}</div>`;
    } else if (highest && next) {
      // Partially applied — show motivation for next tier
      el.innerHTML = `<div class="bg-sc-bulk-inline">✅ ${highest.discount} applied · Add ${next.qty - qty} more for <strong>${next.discount}</strong>!</div>`;
    } else if (next) {
      // No tier hit yet — show motivation
      el.innerHTML = `<div class="bg-sc-bulk-inline">💰 Add ${next.qty - qty} more for <strong>${next.discount}</strong></div>`;
    }
  }

  // ── COD vs PREPAID (10% off prepaid, +₹100 COD) ──
  function renderCodPrepaid() {
    const el = $('#bg-sc-cod-prepaid');
    if (!el || !C.showCodPrepaid || !state.cart || state.cart.item_count === 0) { if (el) el.style.display = 'none'; return; }
    const t = state.cart.total_price / 100; // cart total in rupees
    const prepaidSave = Math.round(t * C.prepaidDiscountPercent / 100);
    const prepaidPrice = t - prepaidSave;
    const codPrice = t + C.codExtraCharge;

    el.style.display = 'block';
    el.innerHTML = `
      <div class="bg-sc-cp-row bg-sc-cp-prepaid">
        <div class="bg-sc-cp-left"><span class="bg-sc-cp-badge prepaid">💳 PREPAID</span><span class="bg-sc-cp-desc">GPay / PhonePe / UPI / Card</span></div>
        <div class="bg-sc-cp-right"><span class="bg-sc-cp-price-val">${fr(prepaidPrice)}</span><span class="bg-sc-cp-save">Save ${fr(prepaidSave)}</span></div>
      </div>
      <div class="bg-sc-cp-row bg-sc-cp-cod">
        <div class="bg-sc-cp-left"><span class="bg-sc-cp-badge cod">📦 COD</span><span class="bg-sc-cp-desc">Cash on Delivery</span></div>
        <div class="bg-sc-cp-right"><span class="bg-sc-cp-price-val">${fr(codPrice)}</span><span class="bg-sc-cp-extra">+${fr(C.codExtraCharge)} fee</span></div>
      </div>`;
  }

  // ── EDD ──
  function renderEDD() {
    const el = $('#bg-sc-edd'); if (!el || !C.showEDD) return;
    el.style.display = 'flex';
    el.innerHTML = `<span class="bg-sc-edd-icon">🚛</span><span>${C.eddText}</span>${C.eddApiEndpoint ? `<div class="bg-sc-edd-pincode"><input type="text" class="bg-sc-edd-input" placeholder="Pincode" maxlength="6" id="bg-sc-edd-pin" /><button class="bg-sc-edd-check" id="bg-sc-edd-btn">Check</button></div>` : ''}`;
  }

  // ── RECENTLY VIEWED ──
  function renderRV() {
    const el = $('#bg-sc-recently-viewed'), car = $('#bg-sc-rv-carousel');
    if (!el || !car || !C.showRecentlyViewed) return;
    const items = RV.get();
    if (!items.length) { el.style.display = 'none'; return; }
    el.style.display = 'block';
    car.innerHTML = items.map(p => `<a href="${p.url}" class="bg-sc-rv-card"><div class="bg-sc-rv-img">${p.image ? `<img src="${p.image.replace(/(\.[^.]+)$/,'_200x$1')}" loading="lazy" />` : ''}</div><p class="bg-sc-rv-name">${p.title}</p></a>`).join('');
  }

  // ── TIMER ──
  function startTimer() {
    if (C.cartReserveMinutes <= 0) return;
    const el = $('#bg-sc-timer'), val = $('#bg-sc-timer-value'); if (!el || !val) return;
    if (state.cart?.item_count > 0) {
      el.style.display = 'flex';
      if (state.timerInterval) clearInterval(state.timerInterval);
      state.timerInterval = setInterval(() => { if (state.timerSeconds <= 0) { clearInterval(state.timerInterval); return; } state.timerSeconds--; val.textContent = `${Math.floor(state.timerSeconds/60)}:${(state.timerSeconds%60).toString().padStart(2,'0')}`; }, 1000);
    } else { el.style.display = 'none'; clearInterval(state.timerInterval); }
  }

  // ══════════════════════════════════════════════════════════════
  // MAIN RENDER
  // ══════════════════════════════════════════════════════════════
  function renderCart() {
    if (!state.cart) return;
    const items = state.cart.items, n = state.cart.item_count;
    const ct = $('#bg-sc-count'); if (ct) ct.textContent = `(${n})`;
    const st = $('#bg-sc-subtotal'); if (st) st.textContent = fp(state.cart.total_price);

    // Savings
    let sav = state.cart.total_discount || 0;
    items.forEach(i => { if (i.original_price > i.final_price) sav += (i.original_price - i.final_price) * i.quantity; });
    const svEl = $('#bg-sc-savings'), svAm = $('#bg-sc-savings-amount');
    if (svEl && svAm) { if (sav > 0) { svEl.style.display = 'flex'; svAm.textContent = fp(sav); } else svEl.style.display = 'none'; }

    const iEl = $('#bg-sc-items'), eEl = $('#bg-sc-empty'), fEl = $('#bg-sc-footer');
    if (items.length > 0) {
      if (iEl) { iEl.innerHTML = items.map((i, x) => renderItem(i, x)).join(''); iEl.style.display = 'block'; }
      if (eEl) eEl.style.display = 'none'; if (fEl) fEl.style.display = 'block';
    } else {
      if (iEl) iEl.style.display = 'none'; if (eEl) eEl.style.display = 'flex'; if (fEl) fEl.style.display = 'none';
    }
    updateProgress(); checkGift(); renderBulk(); renderEDD(); renderRV(); renderCombo(); renderSavingsNudge();

    // Dynamic upsell title
    const uTitle = $('#bg-sc-upsell-title');
    if (uTitle) {
      if (n <= 1) uTitle.textContent = 'Grab Your 2nd — Extra 10% OFF';
      else if (n === 2) uTitle.textContent = 'Add 3rd — Unlock Extra 15% OFF';
      else uTitle.textContent = 'One for Every Outfit';
    }

    // Social proof near BUY NOW
    const proofEl = $('#bg-sc-social-proof');
    if (proofEl) proofEl.innerHTML = '★ 4.8 · 4,50,000+ happy customers';

    ['.cart-count','.cart-count-bubble span','[data-cart-count]','#CartCount'].forEach(s => { const e = $(s); if (e) e.textContent = n; });
  }

  function setLoading(v) { state.isLoading = v; const b = $('#bg-sc-body'); if (b) b.classList.toggle('bg-sc-loading', v); }

  // ── DRAWER ──
  function open() { const d = $('#bg-sidecart'), o = $('#bg-sidecart-overlay'); if (!d) return; state.isOpen = true; d.classList.add('open'); d.setAttribute('aria-hidden','false'); if (o) o.classList.add('open'); document.body.classList.add('bg-sc-body-lock'); }
  function close() {
    const d = $('#bg-sidecart'), o = $('#bg-sidecart-overlay');
    if (!d) return;
    state.isOpen = false;
    d.classList.remove('open'); d.setAttribute('aria-hidden','true');
    if (o) o.classList.remove('open');
    document.body.classList.remove('bg-sc-body-lock');

    // EXIT-INTENT NUDGE — show if cart has 1 item (push for 2nd)
    if (state.cart && state.cart.item_count === 1) {
      showExitNudge();
    }
  }

  function showExitNudge() {
    // Don't show if already shown this session
    if (state._exitNudgeShown) return;
    state._exitNudgeShown = true;
    const nudge = document.createElement('div');
    nudge.className = 'bg-sc-exit-nudge';
    nudge.innerHTML = `<span>Add one more for <strong>Extra 10% OFF</strong> →</span><button class="bg-sc-exit-nudge-btn" onclick="BugarioSideCart.open();this.parentElement.remove();">View Colours</button><button class="bg-sc-exit-nudge-close" onclick="this.parentElement.remove()">✕</button>`;
    document.body.appendChild(nudge);
    setTimeout(() => nudge.classList.add('show'), 50);
    setTimeout(() => { if (nudge.parentElement) nudge.remove(); }, 8000); // Auto-dismiss after 8s
  }

  // ══════════════════════════════════════════════════════════════
  // HTML
  // ══════════════════════════════════════════════════════════════
  function buildHTML() {
    return `
    <div id="bg-sidecart-overlay" class="bg-sc-overlay"></div>
    <aside id="bg-sidecart" class="bg-sc-drawer" role="dialog" aria-hidden="true">
      <header class="bg-sc-header">
        <div class="bg-sc-offer-bar">${C.announcementText}</div>
        <div class="bg-sc-header-row">
          <h2 class="bg-sc-title">🛒 Cart <span class="bg-sc-count" id="bg-sc-count">(0)</span></h2>
          <div class="bg-sc-timer" id="bg-sc-timer" style="display:none;">⏱ <strong id="bg-sc-timer-value">${C.cartReserveMinutes}:00</strong></div>
          <button class="bg-sc-close" id="bg-sc-close">✕</button>
        </div>
      </header>
      <div class="bg-sc-progress" id="bg-sc-progress">
        <div class="bg-sc-progress-message" id="bg-sc-progress-msg"></div>
        <div class="bg-sc-progress-track-wrap" id="bg-sc-progress-track-wrap">
          <div class="bg-sc-progress-track"><div class="bg-sc-progress-fill" id="bg-sc-progress-fill"></div><div class="bg-sc-progress-milestones" id="bg-sc-progress-milestones"></div></div>
          <div class="bg-sc-progress-labels" id="bg-sc-progress-labels"></div>
        </div>
      </div>
      <div class="bg-sc-body" id="bg-sc-body">
        <!-- CART ITEMS -->
        <div class="bg-sc-items" id="bg-sc-items"></div>
        <div class="bg-sc-empty" id="bg-sc-empty" style="display:none;"><div style="opacity:.25;font-size:48px">🛒</div><p class="bg-sc-empty-text">Your cart is empty</p><a href="/collections/all" class="bg-sc-empty-cta">Start Shopping</a></div>

        <!-- SAVINGS NUDGE — "Add 1 more → Save ₹300" -->
        <div class="bg-sc-savings-nudge" id="bg-sc-savings-nudge" style="display:none;"></div>

        <!-- POPULAR COMBO — one tap "Add All 3" -->
        <div class="bg-sc-combo" id="bg-sc-combo" style="display:none;"></div>

        <!-- UPSELLS — THE MONEY ZONE -->
        <div class="bg-sc-upsell" id="bg-sc-upsell" style="display:none;"><h3 class="bg-sc-upsell-title" id="bg-sc-upsell-title">${C.upsellTitle}</h3><div class="bg-sc-upsell-carousel" id="bg-sc-upsell-carousel"></div></div>

        <!-- Secondary sections (below fold) -->
        <div class="bg-sc-bulk-discounts" id="bg-sc-bulk-discounts" style="display:none;"></div>
        <div class="bg-sc-free-gift" id="bg-sc-free-gift" style="display:none;"></div>
        <div class="bg-sc-edd" id="bg-sc-edd" style="display:none;"></div>
        <div class="bg-sc-recently-viewed" id="bg-sc-recently-viewed" style="display:none;"><h3 class="bg-sc-rv-title">Recently Viewed</h3><div class="bg-sc-rv-carousel" id="bg-sc-rv-carousel"></div></div>
        <div class="bg-sc-trust">${C.trustBadges.map(b=>`<div class="bg-sc-trust-badge"><span class="bg-sc-trust-icon">${b.icon}</span><span class="bg-sc-trust-label">${b.label}</span></div>`).join('')}</div>
      </div>
      <footer class="bg-sc-footer" id="bg-sc-footer">
        <div class="bg-sc-savings" id="bg-sc-savings" style="display:none;">You save <strong id="bg-sc-savings-amount"></strong></div>
        <div class="bg-sc-subtotal-row"><span class="bg-sc-subtotal-label">Total <span class="bg-sc-tax-note">(Inc. Taxes)</span></span><span class="bg-sc-subtotal-amount" id="bg-sc-subtotal">₹0</span></div>
        <div class="bg-sc-social-proof" id="bg-sc-social-proof"></div>
        <div id="bg-sc-fastrr-container">
          <div class="shiprocket-headless" data-type="cart">
            <button type="button" class="sr-headless-checkout bg-sc-fastrr-btn" onclick="if(window.shiprocketCheckoutEvents){shiprocketCheckoutEvents.buyCart(event)}else{window.location.href='/checkout'}">
              <span class="bg-sc-btn-text">BUY NOW</span>
              <span class="bg-sc-btn-arrow">→</span>
            </button>
          </div>
        </div>
      </footer>
    </aside>
    ${C.showStickyBtn ? `<button class="bg-sc-sticky-btn" id="bg-sc-sticky-btn"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg><span class="bg-sc-sticky-count" id="bg-sc-sticky-count">0</span></button>` : ''}
    ${C.showBottomBar ? `<div class="bg-sc-bottom-bar" id="bg-sc-bottom-bar" style="display:none;"><div class="bg-sc-bottom-bar-left"><span class="bg-sc-bottom-bar-count" id="bg-sc-bottom-count">0</span><span class="bg-sc-bottom-bar-total" id="bg-sc-bottom-total">₹0</span></div><button class="bg-sc-bottom-bar-btn" id="bg-sc-bottom-btn">View Cart</button></div>` : ''}`;
  }

  // ══════════════════════════════════════════════════════════════
  // SUPPRESS NATIVE SHOPIFY CART
  // ══════════════════════════════════════════════════════════════
  function suppressNativeCart() {
    // 1. CSS: Force-hide ALL native cart elements
    const style = document.createElement('style');
    style.id = 'bg-sc-suppress';
    style.textContent = `
      cart-drawer:not(#bg-sidecart),
      .cart-drawer:not(#bg-sidecart),
      .mini-cart:not(#bg-sidecart),
      .drawer--cart:not(#bg-sidecart),
      .cart-notification, .cart-popup,
      [data-cart-drawer]:not(#bg-sidecart),
      .shopify-section-cart-drawer:not(#bg-sidecart-root),
      #cart-drawer:not(#bg-sidecart),
      #mini-cart:not(#bg-sidecart),
      .side-cart:not(#bg-sidecart),
      .cart-drawer-overlay,
      [id*="cart-drawer"]:not(#bg-sidecart):not(#bg-sidecart-root),
      [class*="cart-drawer"]:not(#bg-sidecart):not(#bg-sidecart-root) {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        width: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
        position: fixed !important;
        left: -9999px !important;
      }
    `;
    document.head.appendChild(style);

    // 2. MutationObserver: Kill any native cart that gets dynamically injected
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          const el = node;
          // Check if this is a native cart element
          const isNativeCart = (
            (el.tagName === 'CART-DRAWER' || el.tagName === 'CART-NOTIFICATION') ||
            (el.classList && (el.classList.contains('cart-drawer') || el.classList.contains('mini-cart') || el.classList.contains('cart-notification'))) ||
            (el.id && el.id.includes('cart-drawer') && el.id !== 'bg-sidecart')
          );
          if (isNativeCart) {
            el.remove();
            console.log('[BG] Killed native cart element:', el.tagName, el.id || el.className);
          }
        }
        // Also catch attribute changes that "open" native carts
        if (m.type === 'attributes' && m.target.id !== 'bg-sidecart' && m.target.id !== 'bg-sidecart-overlay') {
          const t = m.target;
          if (t.tagName === 'CART-DRAWER' || (t.classList && t.classList.contains('cart-drawer'))) {
            t.removeAttribute('open');
            t.style.display = 'none';
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'style'] });

    // 3. Override theme cart functions — run multiple times to catch late-loading scripts
    function killThemeCart() {
      // Dawn / Sense / Craft themes
      const nativeDrawer = document.querySelector('cart-drawer');
      if (nativeDrawer && nativeDrawer.id !== 'bg-sidecart') {
        nativeDrawer.style.display = 'none';
        nativeDrawer.remove();
      }
      const nativeNotif = document.querySelector('cart-notification');
      if (nativeNotif) nativeNotif.remove();

      // Theme JS overrides
      if (window.theme?.CartDrawer?.prototype) {
        window.theme.CartDrawer.prototype.open = () => {};
        window.theme.CartDrawer.prototype.renderContents = () => {};
      }
    }
    // Run immediately + after delays (theme scripts load async)
    killThemeCart();
    setTimeout(killThemeCart, 500);
    setTimeout(killThemeCart, 1500);
    setTimeout(killThemeCart, 3000);

    // 4. Block section fetch requests that load cart drawer HTML
    const origXHR = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      if (typeof url === 'string' && (url.includes('section_id=cart-drawer') || url.includes('sections=cart-drawer'))) {
        console.log('[BG] Blocked native cart section fetch:', url);
        // Redirect to a no-op — fetch an empty section instead
        return origXHR.call(this, method, '/404', ...args);
      }
      return origXHR.call(this, method, url, ...args);
    };

    // 5. Also intercept fetch-based section loads
    const realFetch = window._bgOrigFetch || window.fetch;
    // Don't double-wrap if we already wrapped fetch for ATC interception
    if (!window._bgFetchWrapped) {
      window._bgOrigFetch = window.fetch;
    }

    // 6. Prevent theme from dispatching cart:open / cart:refresh events
    const origDispatch = EventTarget.prototype.dispatchEvent;
    EventTarget.prototype.dispatchEvent = function(event) {
      if (event && event.type && (event.type.includes('cart:open') || event.type === 'cart:refresh' || event.type === 'theme:cart:open')) {
        console.log('[BG] Blocked native cart event:', event.type);
        return false;
      }
      return origDispatch.call(this, event);
    };
  }

  // ══════════════════════════════════════════════════════════════
  // EVENT BINDING
  // ══════════════════════════════════════════════════════════════
  function bind() {
    delegate(document, 'click', '#bg-sc-close', close);
    delegate(document, 'click', '#bg-sidecart-overlay', close);
    delegate(document, 'click', '#bg-sc-continue', close);
    if (C.showStickyBtn) delegate(document, 'click', '#bg-sc-sticky-btn', e => { e.preventDefault(); open(); });
    if (C.showBottomBar) delegate(document, 'click', '#bg-sc-bottom-btn', e => { e.preventDefault(); open(); });

    // Qty
    delegate(document, 'click', '.bg-sc-qty-btn', async e => {
      if (state.isLoading) return;
      const b = e.target.closest('.bg-sc-qty-btn'), line = +b.dataset.line, act = b.dataset.action;
      const cur = state.cart.items[line-1].quantity, nq = act === 'increase' ? cur+1 : Math.max(0, cur-1);
      // OPTIMISTIC: update UI instantly
      const qtyEl = b.parentElement.querySelector('.bg-sc-qty-value');
      if (qtyEl) qtyEl.textContent = nq;
      // API call in background — single call, no loading overlay
      state.cart = await API.change(line, nq);
      renderCart(); loadColorUpsells();
    });
    // Remove
    delegate(document, 'click', '.bg-sc-item-remove', async e => {
      if (state.isLoading) return; const b = e.target.closest('.bg-sc-item-remove'), l = +b.dataset.line;
      const el = b.closest('.bg-sc-item'); if (el) { el.classList.add('bg-sc-item-removing'); await new Promise(r => setTimeout(r, 300)); }
      try { setLoading(true); state.cart = await API.change(l, 0); renderCart(); loadColorUpsells(); } finally { setLoading(false); }
    });
    // Inline variant switch
    delegate(document, 'change', '.bg-sc-item-variant-sel', async e => {
      if (state.isLoading || !state.productData) return;
      const sel = e.target, line = +sel.dataset.line, type = sel.dataset.type, item = state.cart.items[line-1]; if (!item) return;
      const row = sel.closest('.bg-sc-item'), cSel = row.querySelector('[data-type="color"]'), sSel = row.querySelector('[data-type="size"]');
      let newC = cSel?.value || '', newS = sSel?.value || '';
      if (type === 'color' && sSel) {
        const av = state.productData.variants.filter(v => v[state._colorKey] === newC && v.available).map(v => v[state._sizeKey]);
        if (!av.includes(newS)) newS = av[0] || '';
        sSel.innerHTML = av.map(s => `<option ${s===newS?'selected':''}>${s}</option>`).join('');
      }
      const m = state.productData.variants.find(v => v[state._colorKey]===newC && v[state._sizeKey]===newS && v.available);
      if (!m) return;
      try { setLoading(true); await API.change(line, 0); await API.add([{id:m.id, quantity:item.quantity}]); state.cart = await API.get(); renderCart(); loadColorUpsells(); } finally { setLoading(false); }
    });
    // Notes
    delegate(document, 'click', '.bg-sc-item-note-toggle', e => { const l = e.target.closest('.bg-sc-item-note-toggle').dataset.line; const f = $(`.bg-sc-item-note-field[data-line="${l}"]`); if (f) f.style.display = f.style.display==='none'?'block':'none'; });
    delegate(document, 'click', '.bg-sc-item-note-save', async e => { const l = +e.target.closest('.bg-sc-item-note-save').dataset.line; const ta = $(`.bg-sc-item-note-input[data-line="${l}"]`); if (!ta) return; const item = state.cart.items[l-1]; try { setLoading(true); state.cart = await API.change(l, item.quantity, Object.assign({}, item.properties||{}, {_note:ta.value.trim()})); renderCart(); } finally { setLoading(false); } });
    // Upsell size select
    delegate(document, 'change', '.bg-sc-upsell-size-select', e => {
      const sel = e.target, card = sel.closest('.bg-sc-upsell-card'), btn = card.querySelector('.bg-sc-upsell-add');
      if (btn) btn.dataset.variantId = sel.value;
      const opt = sel.options[sel.selectedIndex];
      const pEl = card.querySelector('.bg-sc-upsell-price'), mEl = card.querySelector('.bg-sc-upsell-mrp');
      if (pEl && opt.dataset.price) pEl.textContent = fp(+opt.dataset.price);
      if (mEl && +opt.dataset.cp > 0) mEl.textContent = fp(+opt.dataset.cp);
    });
    // Upsell add — with celebration animation
    delegate(document, 'click', '.bg-sc-upsell-add', async e => {
      if (state.isLoading) return; const btn = e.target.closest('.bg-sc-upsell-add'), card = btn.closest('.bg-sc-upsell-card'), vid = +btn.dataset.variantId;
      try {
        setLoading(true); btn.textContent = 'Adding...'; btn.disabled = true;
        await API.add([{id:vid, quantity:1}]); state.cart = await API.get();
        // CELEBRATION: flash card green, pulse, checkmark
        card.classList.add('bg-sc-card-added');
        btn.textContent = '✓ Added!';
        Ax.track('add_to_cart', {id:vid, value:state.cart.total_price/100});
        renderCart(); loadColorUpsells();
        setTimeout(() => { card.classList.remove('bg-sc-card-added'); }, 1500);
      } catch(e) { btn.textContent = '+ Add'; btn.disabled = false; } finally { setLoading(false); }
    });

    // POPULAR COMBO — Add All
    delegate(document, 'click', '.bg-sc-combo-add', async e => {
      if (state.isLoading) return;
      const btn = e.target.closest('.bg-sc-combo-add');
      const vids = btn.dataset.variants.split(',').map(Number).filter(Boolean);
      if (!vids.length) return;
      try {
        setLoading(true); btn.textContent = 'Adding...'; btn.disabled = true;
        await API.add(vids.map(id => ({id, quantity: 1})));
        state.cart = await API.get();
        btn.textContent = '✓ Added All!';
        renderCart(); loadColorUpsells();
        Ax.track('add_combo', {ids: vids, value: state.cart.total_price/100});
      } catch(e) { btn.textContent = 'Add All'; btn.disabled = false; }
      finally { setLoading(false); }
    });
    // Free gift
    delegate(document, 'click', '.bg-sc-gift-option', e => selectGift(+e.target.closest('.bg-sc-gift-option').dataset.variantId));
    // EDD
    delegate(document, 'click', '#bg-sc-edd-btn', async () => { const pin = $('#bg-sc-edd-pin'); if (!pin || pin.value.length < 5 || !C.eddApiEndpoint) return; try { const r = await (await fetch(C.eddApiEndpoint+encodeURIComponent(pin.value))).json(); const el = $('#bg-sc-edd'); if (el) el.innerHTML = `<span class="bg-sc-edd-icon">🚛</span> ${r.edd||r.message||'Delivers in '+(r.days||'3-5')+' days'}`; } catch(e){} });

    // Escape
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && state.isOpen) close(); });
    // Swipe
    let tx = 0; const dr = $('#bg-sidecart');
    if (dr) { dr.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, {passive:true}); dr.addEventListener('touchend', e => { if (e.changedTouches[0].clientX - tx > 80) close(); }, {passive:true}); }

    // ═══════════════════════════════════════════════════════════
    // INTERCEPT ADD TO CART — OPEN DRAWER INSTANTLY
    // ═══════════════════════════════════════════════════════════
    document.addEventListener('submit', async e => {
      const f = e.target;
      if (f.action && f.action.includes('/cart/add')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const fd = new FormData(f), id = fd.get('id'), qty = +fd.get('quantity') || 1;
        if (!id) return;
        // INSTANT: open drawer immediately with loading state
        open();
        setLoading(true);
        // API calls in background
        await API.add([{id:+id, quantity:qty}]);
        state.cart = await API.get();
        setLoading(false);
        renderCart(); loadColorUpsells();
        Ax.track('add_to_cart', {id:+id, value:state.cart.total_price/100});
      }
    }, true);

    // Intercept fetch-based add to cart (themes using AJAX)
    // Also block native cart drawer section fetches
    const origFetch = window.fetch;
    window._bgFetchWrapped = true;
    window.fetch = function(...a) {
      const u = typeof a[0] === 'string' ? a[0] : a[0]?.url;
      // Block cart drawer section fetches (theme trying to render native cart)
      if (u && (u.includes('section_id=cart-drawer') || u.includes('sections=cart-drawer') || u.includes('section_id=cart-notification'))) {
        console.log('[BG] Blocked section fetch:', u);
        return Promise.resolve(new Response('', { status: 200 }));
      }
      if (u && u.includes('/cart/add')) {
        // INSTANT open
        open(); setLoading(true);
        return origFetch.apply(this, a).then(async r => {
          const c = r.clone();
          try { state.cart = await API.get(); setLoading(false); renderCart(); loadColorUpsells(); } catch(e) { setLoading(false); }
          return c;
        });
      }
      return origFetch.apply(this, a);
    };

    // Cart link intercept — continuous (catches dynamically added links too)
    function interceptCartLinks() {
      $$('a[href="/cart"], a[href="/cart/"]').forEach(l => {
        if (l._bgIntercepted) return; // Don't bind twice
        if (l.textContent.toLowerCase().includes('checkout')) return;
        l._bgIntercepted = true;
        l.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); open(); }, true);
      });
    }
    interceptCartLinks();
    setTimeout(interceptCartLinks, 1000);
    setTimeout(interceptCartLinks, 3000);
    // Also observe for new cart links being added
    new MutationObserver(interceptCartLinks).observe(document.body, { childList: true, subtree: true });

    // View Full Cart link — opens /cart page (for users who want Shopify's native cart)
    delegate(document, 'click', '#bg-sc-viewcart', e => { close(); /* let default href work */ });
  }

  // ══════════════════════════════════════════════════════════════
  // INIT
  // ══════════════════════════════════════════════════════════════
  async function init() {
    initAB();
    suppressNativeCart();

    const c = document.createElement('div'); c.id = 'bg-sidecart-root'; c.innerHTML = buildHTML(); document.body.appendChild(c);
    state.cart = await API.get();
    renderCart(); loadColorUpsells();
    RV.load(); RV.track();
    bind();

    // ═══════════════════════════════════════════════════════════
    // OVERRIDE GEMPAGES STICKY ATC BUTTON
    // The GemPages button does fetch('/cart/add.js').then(() => location.href = '/cart')
    // We need to intercept this so it opens OUR drawer instead of navigating
    // ═══════════════════════════════════════════════════════════
    function overrideStickyATC() {
      const stickyBtn = document.getElementById('le-submit-btn');
      if (!stickyBtn || stickyBtn._bgOverridden) return;
      stickyBtn._bgOverridden = true;

      // Clone and replace to remove ALL existing event listeners
      const newBtn = stickyBtn.cloneNode(true);
      stickyBtn.parentNode.replaceChild(newBtn, stickyBtn);

      newBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        newBtn.innerText = "ADDING...";
        newBtn.style.opacity = "0.7";

        // Get variant ID same way GemPages does
        let variantId = document.querySelector('[name="id"]')?.value;
        if (!variantId) {
          const form = document.querySelector('form[action$="/cart/add"]');
          variantId = form?.querySelector('[name="id"]')?.value;
        }

        if (variantId) {
          // Open drawer INSTANTLY
          open();
          setLoading(true);

          await API.add([{ id: parseInt(variantId), quantity: 1 }]);
          state.cart = await API.get();

          setLoading(false);
          renderCart();
          loadColorUpsells();
          Ax.track('add_to_cart', { id: parseInt(variantId), value: state.cart.total_price / 100 });
        }

        newBtn.innerText = "ADD TO CART";
        newBtn.style.opacity = "1";
      }, true);

      console.log('[BG] Sticky ATC button overridden ✓');
    }

    // Run after delays (GemPages loads async)
    overrideStickyATC();
    setTimeout(overrideStickyATC, 1000);
    setTimeout(overrideStickyATC, 3000);
    setTimeout(overrideStickyATC, 5000);

    console.log('🛒 Bugario SideCart v2.2 ready');
    console.log('[BG] Product handle:', C.upsellProductHandle);
    console.log('[BG] Fastrr:', typeof window.shiprocketCheckoutEvents !== 'undefined' ? 'DETECTED ✓' : 'NOT FOUND — checkout will redirect to /checkout');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.BugarioSideCart = { open, close, toggle: () => state.isOpen ? close() : open(), refresh: async () => { state.cart = await API.get(); renderCart(); loadColorUpsells(); } };
})();
